_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
directoryLegacyPowerUps = require './directory-legacy-power-ups'
DirectoryPluginItemView = require './directory-plugin-item-view'
Format = require 'lib/markdown/format'
l = require 'lib/localize'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
PowerUpItemDetailsView = require 'views/board-menu/power-up-item-details-view'
t = require('views/internal/recup-with-helpers')('directory')
React = require 'react'
xtend = require 'xtend'

class DirectoryListing extends React.Component
  displayName: 'Directory Listing'

  render: t.renderable ->
    { categories, description, onCategoryClick } = @props
    t.div ->
      t.div ->
        t.icon 'information', class: 'icon-lg'
        _.map categories, (category) ->
          t.a '.category-link', { href: '#', onClick: -> onCategoryClick(category) }, ->
            t.format category
      t.div '.directory-listing-content', ->
        t.raw Format.markdownAsHtml(description)

module.exports = class DirectoryListingView extends BaseDirectoryView
  className: 'directory-individual-listing'

  initialize: ({ @directoryView, @plugin, @currentPage }) ->
    super

  navigateToCategory: (category) ->
    @directoryView.navigate('category', category, null)

  renderContent: ->
    React.createElement DirectoryListing, {
      description: PluginIOCache.get(@plugin).getDescription()
      categories: @plugin.get('categories')
      onCategoryClick: (category) => @navigateToCategory(category)
    }

  render: ->
    @appendSubview @subview(DirectoryPluginItemView, @model, {
      @plugin, @currentPage
    }, @plugin.id)

    powerUp = _.findWhere directoryLegacyPowerUps, { id: @plugin.id }

    if powerUp
      name = powerUp.name
      @appendSubview @subview(PowerUpItemDetailsView, @model, {
        powerUp: xtend powerUp,
          displayName: l(['power ups', name, 'name'])
          description: l(['power ups', name, 'description'])
        isGrandfathered: name in @model.get('powerUps')
      })

      return @
    else
      super



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-listing-view.coffee